"use strict";

var _defineProperty = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/defineProperty.js");

var _objectWithoutProperties = require("/home/circleci/project/frontends/frontdoor/node_modules/@babel/runtime/helpers/objectWithoutProperties.js");

var _excluded = ["color"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);

  __setModuleDefault(result, mod);

  return result;
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IconQuestionMark = void 0;

var React = __importStar(require("react"));

exports.IconQuestionMark = React.forwardRef(function (_ref, forwardedRef) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? "currentColor" : _ref$color,
      props = _objectWithoutProperties(_ref, _excluded);

  return React.createElement("svg", _objectSpread(_objectSpread({
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {}, {
    ref: forwardedRef
  }), React.createElement("path", {
    d: "M20.0008 0C8.97393 0 0 8.97223 0 20C0 31.0278 8.9719 40 20.0008 40C31.0296 40 40 31.0278 40 20C40 8.9707 31.0301 0 20.0008 0ZM20.0008 36.7903C10.7442 36.7903 3.21251 29.2585 3.21251 19.9995C3.21251 10.7405 10.7442 3.21059 20.0008 3.21059C29.2594 3.21059 36.789 10.7426 36.789 19.9995C36.789 29.2585 29.2594 36.7903 20.0008 36.7903ZM19.6825 26.4456C18.9703 26.4456 18.3615 26.6983 17.8582 27.1996C17.3549 27.703 17.1043 28.3117 17.1043 29.0219C17.1043 29.7341 17.3549 30.343 17.8582 30.8462C18.3616 31.3495 18.9703 31.6003 19.6825 31.6003C20.3946 31.6003 21.0034 31.3496 21.5067 30.8462C22.008 30.3429 22.2607 29.7341 22.2607 29.0219C22.2607 28.3098 22.01 27.7009 21.5067 27.1996C21.0054 26.6983 20.3966 26.4456 19.6825 26.4456ZM25.3364 9.86963C24.5805 9.36827 23.727 8.99827 22.7742 8.75753C21.8213 8.5168 20.8425 8.39743 19.8379 8.39743C18.877 8.39743 17.956 8.5546 17.0767 8.86893C16.1973 9.18127 15.4175 9.60503 14.7392 10.1382C14.0588 10.6714 13.5158 11.2881 13.1079 11.9884C12.7001 12.6886 12.4972 13.4247 12.4972 14.1986C12.4972 14.8253 12.7001 15.3008 13.1079 15.627C13.5157 15.9513 13.9912 16.1124 14.5363 16.1124C15.0376 16.1124 15.4315 16.007 15.712 15.7981C15.9945 15.5892 16.2292 15.3346 16.4182 15.0302C16.6072 14.7258 16.7723 14.3975 16.9195 14.0415C17.0667 13.6853 17.2577 13.3551 17.5004 13.0527C17.7411 12.7503 18.0554 12.4937 18.4434 12.2848C18.8293 12.0759 19.3585 11.9705 20.0269 11.9705C20.9679 11.9705 21.706 12.2052 22.2391 12.6767C22.7723 13.1482 23.0388 13.8127 23.0388 14.6681C23.0388 15.1913 22.9036 15.6529 22.635 16.0488C22.3664 16.4467 22.0282 16.8286 21.6204 17.1947C21.2126 17.5608 20.7749 17.9149 20.3035 18.2611C19.832 18.6052 19.3923 18.9772 18.9846 19.3751C18.5767 19.773 18.2365 20.2067 17.966 20.6782C17.6935 21.1497 17.5582 21.6988 17.5582 22.3255C17.5582 22.8268 17.7253 23.3023 18.0595 23.7519C18.3937 24.2035 18.895 24.4263 19.5654 24.4263C20.0886 24.4263 20.4806 24.3428 20.7431 24.1757C21.0037 24.0086 21.2067 23.7957 21.3539 23.5331C21.4991 23.2725 21.6204 22.984 21.7139 22.6697C21.8094 22.3573 21.9507 22.0629 22.1377 21.7903C22.3048 21.5397 22.5614 21.289 22.9075 21.0383C23.2537 20.7876 23.6356 20.5091 24.0534 20.2067C24.4712 19.9043 24.9068 19.5681 25.3584 19.202C25.808 18.836 26.2178 18.4341 26.5819 17.9945C26.9479 17.5548 27.2463 17.0634 27.4771 16.5203C27.7058 15.9772 27.8232 15.3605 27.8232 14.6681C27.8232 13.56 27.5984 12.6071 27.1468 11.8153C26.6953 11.0195 26.0924 10.371 25.3364 9.86963Z",
    fill: color
  }));
});